import { Component } from '@angular/core';

@Component({
  selector: 'app-card-gamification',
  templateUrl: './card-gamification.component.html',
  styleUrls: ['./card-gamification.component.css']
})
export class CardGamificationComponent {

  gameData = {
    level: 13,
    progress_level: 60,
    total_points: 1500,
    position: 10,
    last_achievements: [
      {
        title: 'Achievement 1',
        image_path: '../../assets/images/medal.png'
      },
      {
        title: 'Achievement 2',
        image_path: '../../assets/images/medal.png'
      },
      {
        title: 'Achievement 3',
        image_path: '../../assets/images/medal.png'
      },
    ]
  }
}
